import { IUnitResponse } from '@kcftech/prometheustypescriptapiclient';
import { Dropdown, DropdownLabelRenderer } from 'components/dropdown/Dropdown';
import { useInfiniteUnitsDataSource } from 'custom_hooks/data_hooks/data_source/unitDataSource';
import { dropdownTriggerStyles } from 'pages/Settings/ThirdPartySensorModels/styled';
import { useEffect } from 'react';
import { tokens } from 'styles/tokens';

const renderLabel: DropdownLabelRenderer<IUnitResponse> = ({ value, isDisabled }) => {
    if (!value) {
        return (
            <div title={isDisabled ? 'Select a Data Type to enable' : undefined}>
                Select a unit
            </div>
        );
    }

    return <div>{value.Name}</div>;
};

export type UnitsDropdownProps = Readonly<{
    value: IUnitResponse | undefined;
    onChange: (newValue: IUnitResponse | undefined) => void;
    physicalQuantityCode?: string;
    disabled?: boolean;
}>;

export function UnitsDropdown({
    value,
    onChange,
    physicalQuantityCode,
    disabled,
}: UnitsDropdownProps) {
    const {
        results,
        hasNext,
        loadNext,
        isLoading,
        filter,
        setFilter,
    } = useInfiniteUnitsDataSource({
        name: 'units-dropdown',
        defaultFilter: {
            physicalQuantityCode,
        },
        enabled: !disabled,
    });

    useEffect(() => {
        setFilter((currentFilter) => ({ ...currentFilter, physicalQuantityCode }));
    }, [setFilter, physicalQuantityCode]);

    return (
        <Dropdown<IUnitResponse>
            trigger={{
                style: {
                    ...dropdownTriggerStyles,
                    backgroundColor: tokens.grey.light,
                    border: `2px solid ${tokens.border.default}`,
                },
            }}
            dataKey={(item) => item.Id}
            data={{
                items: results,
                hasMore: hasNext ?? false,
                onLoadMore: loadNext,
                isLoading,
            }}
            filterable={{
                placeholder: 'Search units',
                filterText: filter.nameSearch ?? '',
                onChange: (nameSearch) =>
                    setFilter((existing) => ({ ...existing, nameSearch })),
            }}
            value={value}
            renderItem={({ item }) => item.Name}
            renderLabel={renderLabel}
            onChange={onChange}
            isDisabled={disabled}
        />
    );
}
